<template>
	<div class="form-group clearfix">
		<div :class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}">
			<label v-if="field.question" class="mr-2 align-top" :for="field.id">
				{{ field.question }}
				<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
			</label>
            <small 
        v-if="requiredIncomplete"
        class="ml-1" style="color:#FF0000"    
    >{{  $t('required')}}</small>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
			<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
		</div>
		<textarea-autosize
			class="form-control align-top"
			:class="{'float-right': (field.labelStyle=='justify'),
            'requiredincomplete': requiredIncomplete,
        }"
			:style="{ display: (field.labelStyle=='justify'||field.labelStyle=='inline' ? 'inline' : ''), width: (field.labelStyle=='justify'||field.labelStyle=='inline' ? 'auto' : '') }"
			v-model="field.value"
			:readonly="readonly"
			@keydown.native="checkWords"
			:id="field.id"
			:aria-label="field.question"
		></textarea-autosize>
		<WordCharCounter
			v-if="field.enableCount"
			:text="field.value || ''"
			:limit="(field.countLimit === null || field.countLimit === '') ? 100 : field.countLimit"
			:mode="(field.countMode === null || field.countMode === '') ? 'words' : field.countMode"
            limit-exceeded="limitExceeded"
		/>

	</div>
</template>

<script>
import WordCharCounter from "@/components/WordCharCounter.vue";

export default {
	props: ['field', 'readonly','viewAs'],
	data() {
		return {
			'viewinfo': false
		}
	},
	components: {
		WordCharCounter
	},
	methods: {
		checkWords(e) {
			if (this.field.maxWords) {
				var BACKSPACE  = 8;
				var DELETE     = 46;
				var valid_keys = [BACKSPACE, DELETE];
				var words      = this.field.value.split(/\s+/);
				if (words.length > this.field.maxWords && valid_keys.indexOf(e.keyCode) === -1) {
					e.preventDefault();
				}
			}
		},
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        },
        limitExceeded(payload){
            this.$emit("limit-exceeded", payload);
        }
	},
    computed:{
        requiredIncomplete() {
            return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
            && this.field.required && !this.field.value;
        },
        hasInfo() {
        	if(this.field.info){
        		return true;
        	}
        	return false;
        }
    }
};
</script>
